// extracted by mini-css-extract-plugin
module.exports = {"form":"SendDetailsForm_form__2y79F"};